<template>
<layout-content>
  <template #toolbar>
    <data-time-query :query="query" />

    <site-query :sites="filterSites" :query="query" />

    <factor-tree-query ref="factor-tree" :factor-tree="factorTree" :query="query" />

    <completed-query v-model="query.isAuditCompleted" @change="onAuditCompletedChanged" />

    <!-- <el-checkbox v-model="query.isMultipleIntegral" size="small" label="重积分" border v-if="query.isAuditCompleted !== false" /> -->

    <el-button
      :disabled="canNotSearch"
      type="orange"
      size="small"
      icon="el-icon-search"
      @click="onSearchBtnClick"
    >查询</el-button>

    <el-button
      :disabled="dataList.length === 0"
      type="success"
      size="small"
      icon="el-icon-download"
      @click="onDownloadBtnClick"
    >导出</el-button>
  </template>

  <template #body>
    <data-wrapper>
      <template #header>
        <unit-switch
          :default-unit-prop.sync="unitProp"
          @change="onUnitPropChange"
        />

        <display-type
          :default-display-type.sync="displayType"
          style="margin-left:20px;"
          @change="onDisplayTypeChanged"
        />

        <dimension-type :default-dimension-type.sync="dimension" @change="onDimensionChanged" />

        <el-button size="small" @click="onOpenEditor">标记说明</el-button>
      </template>

      <!-- <data-table
        v-if="displayType === 1"
        ref="dataTable"
        :key="dataTableKey"
        :columns="tableColumns"
        :data="tableDataList"
        :pagination="pagination"
        selected-style
      /> -->

      <z-table
        v-if="displayType === 1"
        ref="dataTable"
        :key="dataTableKey"
        :columns="tableColumns"
        :data="tableDataList"
        :pagination="pagination"
        selected-row-style
        class="legend-table no-wrap-table"
      >
        <template v-for="(column, i) in tableColumns" :slot="column.prop" :lable="column.label" :width="column.width" slot-scope="{row}">
          <div :key="i" :class="` ${row[column.prop + 'Integral'] ? 'integral-data' : 'normal-data'}`">
            {{row[column.prop]}}
          </div>
        </template>
      </z-table>

      <template v-else>
        <x-y-chart
          v-for="data in dataList"
          v-if="data.dimensions.length > 0"
          :key="data.id"
          :data-config="data"
          :unit-prop="unitProp"
          chart-type="line"
          :stack-type="0"
          :download-name="downloadName"
          chart-min-height="400px"
          chart-height="auto"
          selected-change-with-data-changed
          style="flex:1 0 100%;"
        />
      </template>
    </data-wrapper>
  </template>

  <template #editor>
    <editor
      ref="editor"
    />
  </template>
</layout-content>
</template>

<script>
import YaoBaseSiteFactorData from '../../../YaoBaseSiteFactorData'
import DeviceCategoryConfig from '../../../../model/DeviceCategoryConfig'
import CSVDownloader from '../../../../utils/CSVDownloader'

import LayoutContent from '../../../../components/Layout/Content'
import DataTimeQuery from '../../../../components/Data/Query/DataTimeQuery'
import SiteQuery from '../../../../components/Data/Query/SiteQuery'
import CompletedQuery from '../../../../components/Data/Query/CompletedQuery'
import DataWrapper from '../../../../components/Data/DataWrapper'
import UnitSwitch from '../../../../components/Data/UnitSwitch'
import DisplayType from '../../../../components/Data/DisplayType'
import DimensionType from '../../../../components/Data/DimensionType'
import XYChart from '../../../../components/DataChart/XYChart'
import ZTable from '../../../06Data-Management/02Normal/08VOCs-Data-Compare/ZTable'
import ZTablePagination from '../../../06Data-Management/02Normal/08VOCs-Data-Compare/ZTablePagination'
import Editor from '../../../06Data-Management/00Data-Download/Editor.vue'

const DIMENSION_CONFIGS = [{
  prop: 'siteName',
  label: '站房',
  showUnit: true
}, {
  prop: 'factorName',
  label: '因子',
  showUnit: false
}]

export default {
  name: 'NormalFactor42',
  routeInfo: {
    label: '常规4+2',
    icon: 'fa fa-users'
  },
  extends: YaoBaseSiteFactorData,
  components: { ZTable, LayoutContent, DataTimeQuery, SiteQuery, CompletedQuery, DataWrapper, UnitSwitch, DisplayType, DimensionType, XYChart, Editor },
  data: () => ({
    query: {
      factorIds: [],
      isMultipleIntegral: true
    },
    displayType: 2,
    dataTableKey: 0,
    tableColumns: Object.freeze([]),
    tableDataList: Object.freeze([]),
    pagination: new ZTablePagination(1, 24)
  }),
  computed: {
    excludeFactorIdMap: () => ({
      1023: true,
      1024: true,
      1025: true,
      1028: true,
      1031: true,
      1032: true,
      1033: true,
      1034: true,
      1035: true,
      1036: true,
      1045: true,
      1046: true,
      1047: true,
      1048: true,
      1049: true,
      1050: true,
      1051: true,
      1052: true,
      1053: true,
      1054: true,
      1055: true,
      1056: true,
      7001: true,
      9226: true,
      9227: true,
      9228: true
    }),
    siteDeviceCategoryConfig () {
      return [
        new DeviceCategoryConfig(1, true),
        new DeviceCategoryConfig(process.env.SO2_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.NO_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.CO_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.O3_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.PM_DEVICE_CATEGORY, false)
      ]
    },
    downloadName: () => '常规因子',
    currentDimensions () {
      return Object.values(this.dataList.reduce((map, dataConfig) => dataConfig.dimensions.reduce((map, dimension) => {
        let dimensionId = dimension.id

        if (!map[dimensionId]) {
          map[dimensionId] = dimension
        }

        return map
      }, map), {}))
    }
  },
  methods: {
    getSeriesParam (dimension, dimensionIds) {
      return {
        type: 'line',
        showSymbol: false
      }
    },
    getEditor () {
      return this.$refs['editor']
    },
    onOpenEditor (model) {
      let refEditor = this.getEditor()
      refEditor && refEditor.open()
    },
    // onAuditCompletedChanged () {
    //   let {query} = this
    //   if (query.isAuditCompleted === 'isFuse') {
    //     query.isFuse = true
    //     delete query.isAuditCompleted
    //   } else {
    //     query.isFuse = false
    //   }
    //   if (query.isAuditCompleted === true) {
    //     query.isGetInvalidData = false
    //   } else {
    //     query.isGetInvalidData = true
    //   }

    //   query.isMultipleIntegral = false
    //   this.afterSetSiteIds()
    // },
    onDownloadBtnClick () {
      let {currentQuery: {beginTime, endTime}, tableColumns, dataList, currentDimensions, unitProp} = this
      let dimensionConfig = DIMENSION_CONFIGS[this.dimension]
      let filename = `${new Date(beginTime).format('YYYY-MM-DD')}_${new Date(endTime).format('YYYY-MM-DD')}`
      let tableColumnsLen = tableColumns.length
      let csvDataList = []

      let headerColumns = ['', '']
      for (let i = 2; i < tableColumnsLen; i++) {
        headerColumns.push(tableColumns[i].label, '')
      }
      csvDataList.push(headerColumns)

      headerColumns = [tableColumns[0].label, tableColumns[1].label]
      for (let i = 2; i < tableColumnsLen; i++) {
        headerColumns.push('监测值', `标记`)
      }
      csvDataList.push(headerColumns)

      dataList.reduce((csvDataList, dataConfig) => {
        let {name, seriesMap} = dataConfig
        let {dimensions} = dataConfig

        return dataConfig.dataTimes.reduce((csvDataList, dataTimeObj) => {
          let dataTime = dataTimeObj[1]
          csvDataList.push(currentDimensions.reduce((csvDataRow, dimension) => {
            let dimensionId = dimension.id
            let seriesItem = seriesMap[dimensionId]

            if (seriesItem) {
              let data = seriesItem[dataTime] || {}
              const {value} = data
              const flags = []

              if (data.isHaveIntegral) {
                flags.push('重积分')
              }

              const displayFlags = data.displayFlags || []

              if (displayFlags[0]) {
                flags.push(displayFlags[0])

                if (displayFlags[1]) {
                  flags[flags.length - 1] += `: ${displayFlags[1]}`
                }
              }

              csvDataRow.push(Number.isFinite(value) ? value : '--', flags.join(','))
            } else {
              csvDataRow.push('--', '--')
            }

            return csvDataRow
          }, [dataTime, `${name}${!dimensionConfig.showUnit && dimensions[0] && dimensions[0][unitProp] ? `(${dimensions[0][unitProp]})` : ''}`]))
          return csvDataList
        }, csvDataList)
      }, csvDataList)

      CSVDownloader(csvDataList, filename)
    },
    onDisplayTypeChanged (displayType) {
      if (displayType === 1) {
        setTimeout(() => {
          this.$refs.dataTable.doLayout()
        }, 0)
      }
    },
    onDimensionChanged () {
      this.formatData()
    }
  },
  watch: {
    dataList (dataList) {
      let {unitProp} = this
      let dimensionConfig = DIMENSION_CONFIGS[this.dimension]
      let {showUnit} = dimensionConfig

      this.tableColumns = Object.freeze(this.currentDimensions.reduce((tableColumns, factor) => {
        let unit = factor[unitProp]
        tableColumns.push({
          prop: factor.id,
          label: `${factor.name}${showUnit && unit ? `(${unit})` : ''}`,
          width: 140,
          align: 'left'
        })
        return tableColumns
      }, [{
        prop: 'dataTime',
        label: '时间',
        width: 160,
        align: 'left',
        fixed: true
      }, {
        prop: dimensionConfig.prop,
        label: dimensionConfig.label,
        width: 160,
        align: 'left',
        fixed: true
      }]))

      this.tableDataList = Object.freeze(dataList.reduce((list, dataConfig) => {
        let {name, dimensions, seriesMap} = dataConfig
        return dataConfig.dataTimes.reduce((list, dataTimeObj) => {
          let dataTime = dataTimeObj[1]
          list.push(dimensions.reduce((formatData, dimension) => {
            let dimensionId = dimension.id
            let seriesItem = seriesMap[dimensionId]
            let data = seriesItem[dataTime]

            if (data) {
              const {value, displayFlags} = data
              formatData[dimensionId] = Number.isFinite(value) ? `${value}${displayFlags[0] ? `(${displayFlags[0]}${displayFlags[1] ? `: ${displayFlags[1]}` : ''})` : ''}` : (displayFlags[0] ? `${displayFlags[0]}${displayFlags[1] ? `: ${displayFlags[1]}` : ''}` : '--')
              formatData[dimensionId + 'Integral'] = data.isHaveIntegral
            } else {
              formatData[dimensionId] = '--'
            }

            // if (data) {
            //   const {value, displayFlag} = data
            //   formatData[dimensionId] = Number.isFinite(value) ? `${value}${displayFlag ? `(${displayFlag})` : ''}` : (displayFlag || '--')
            //   formatData[dimensionId + 'Integral'] = data.isHaveIntegral
            // } else {
            //   formatData[dimensionId] = '--'
            // }

            // formatData[dimensionId] = data ? `${data.value}(${data.dasFlag}${isAuditCompleted ? `, ${data.auditFlag}` : ''}${data.isHaveIntegral ? ',重积分' : ''})` : '--'

            // if (data && data.isHaveIntegral) {
            //   formatData[dimensionId] = data.value ? data.value : '--'
            // } else {
            //   if (isAuditCompleted) {
            //     if (data.auditFlag !== 'DELETE') {
            //       formatData[dimensionId] = data.value ? data.value : '--'
            //     } else {
            //       formatData[dimensionId] = '--'
            //     }
            //   } else {
            //     formatData[dimensionId] = data ? `${data.value ? data.value : '--'}(${data.dasFlag}${isAuditCompleted ? `, ${data.auditFlag !== 'DELETE' ? 'R' : 'O'}` : ''})` : '--'
            //   }
            // }
            // formatData[dimensionId + 'Integral'] = data ? data.isHaveIntegral : false

            return formatData
          }, {
            [dimensionConfig.prop]: `${name}${!showUnit && dimensions[0] && dimensions[0][unitProp] ? `(${dimensions[0][unitProp]})` : ''}`,
            dataTime
          }))
          return list
        }, list)
      }, []))

      if (this.displayType !== 1) {
        return
      }

      this.pagination.no = 1

      setTimeout(() => {
        this.$refs.dataTable.doLayout()
      }, 0)
    }
  }
}
</script>

<style lang="scss" scoped>
.layout-content-wrapper {
  /deep/ {
    .layout-content-body {
      .layout-content-body-inner {
        overflow: hidden !important;
      }
    }
  }
}
.no-wrap-table {
  --z-table-white-space: nowrap;
}
legend {
  font-size: 16px;
  padding: 0 1em;
  color: #303133;
  text-align: center;
}
.z-table {
  min-height: 0;
}
.integral-data {
  color: #409EFF;
}
.toolbar .el-checkbox {
  font-size: 17px;
  height: 32px;

  /deep/ .el-checkbox__label {
    line-height: 16px;
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/03Data-Display/00Normal/01Factor42/index.vue